import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  it: {
    nav: { tours: "I Tour", guide: "La Guida", about: "Chi sono", request: "Richiedi prezzi", cta: "Prenota il tuo tour" },
    hero: {
      overline: "Tour privati con guida locale — Napoli · Campi Flegrei · Isole · Costiera",
      line1: "Terra di miti,",
      line2: "mare e vulcani",
      sub: "Scopri Napoli, i Campi Flegrei, le Costiere Amalfitana e Sorrentina e le isole del golfo attraverso tour privati costruiti interamente su misura per te. Vivi la Campania oltre i percorsi turistici tradizionali — crea la tua esperienza perfetta e richiedi un preventivo personalizzato!",
      cta1: "Scopri i tour",
      cta2: "Richiedi un preventivo",
      badge: "Napoli, Campania — Italia",
    },
    marquee: ["Napoli", "Pozzuoli", "Solfatara", "Lago d'Averno", "Lago Lucrino", "Baia", "Pompei", "Capri", "Ischia", "Procida", "Positano", "Amalfi", "Ravello"],
    tours: {
      overline: "I Tour",
      title1: "Dieci meraviglie.",
      title2: "Non fartele raccontare, vivile!",
      sub: "Ogni tour è un'intera giornata, privata e modellata su di te. Tocca una destinazione per scoprire il programma.",
      fullDay: "Giornata intera",
      day1: "Giorno 1",
      day2: "Giorno 2",
      open: "Scopri il tour",
    },
    modal: {
      highlights: "Cosa vedremo",
      cta: "Richiedi il prezzo di questo tour",
      close: "Chiudi",
      note: "Prezzo su richiesta — ti rispondo in privato con un preventivo su misura.",
    },
    manifesto: {
      overline: "La Guida",
      title1: "Ti Guido",
      title2: "io!",
      chapters: [
        {
          n: "01",
          title: "Una guida, non un'agenzia",
          text: "Niente gruppi da trenta persone e bandierine alzate. Con me cammini con chi questo territorio lo vive ogni giorno: vicoli, mercati, panorami e storie che non trovi sulle guide cartacee.",
        },
        {
          n: "02",
          title: "Ogni tour è su misura",
          text: "Vuoi più storia, più mare o più cibo? Il ritmo lo decidi tu. Ogni giornata viene costruita insieme, in base ai tuoi interessi, ai tempi e alla stagione.",
        },
        {
          n: "03",
          title: "Prezzi chiari, in privato",
          text: "Non pubblico listini perché ogni esperienza è diversa: numero di ospiti, durata, biglietti e transfer cambiano il prezzo. Scrivimi il tour che vuoi fare e ti rispondo personalmente con un preventivo trasparente.",
        },
      ],
    },
    about: {
      overline: "Chi sono",
      title: "La mia storia, la tua sicurezza.",
      photoAlt: "Guido Formichella sul belvedere di Posillipo con il golfo di Napoli alle spalle",
      intro: "Mi chiamo Guido Formichella. Dopo una laurea in Giurisprudenza, ho scelto di seguire la mia vera natura: trasformare il tempo libero delle persone in ricordi indimenticabili.",
      points: [
        { lead: "Dalla gavetta ai viaggi nel mondo:", text: "ho vissuto il turismo sul campo come capo animatore nei villaggi turistici e ho lavorato per anni nelle agenzie di viaggio, imparando a gestire ogni dettaglio per rendere una vacanza perfetta." },
        { lead: "La scelta:", text: "ho girato il mondo in lungo e in largo e visto panorami straordinari, ma alla fine ho capito una cosa: il posto più bello resta casa mia." },
        { lead: "La missione:", text: "da viaggiatore, ho deciso di far viaggiare al meglio gli altri. Oggi metto la mia esperienza al tuo servizio, portandoti alla scoperta di Napoli, Pozzuoli, del Lago d'Averno, del Lago Lucrino, della Costiera e delle nostre isole. Non sarò una semplice guida, ma un amico del posto che sa come farti vivere ogni angolo con la massima sicurezza, professionalità e divertimento." },
      ],
      closing: "Sali a bordo. Ti faccio innamorare della mia terra.",
    },
    enquiry: {
      overline: "Prezzi su richiesta",
      title1: "Scegli l'esperienza",
      title2: "che desideri vivere.",
      sub: "Riceverai un preventivo personalizzato in base alle tue esigenze. Compila il modulo: ti rispondo personalmente via email con il prezzo e tutti i dettagli per organizzare la tua giornata.",
      name: "Nome e cognome",
      namePh: "Maria Rossi",
      email: "La tua email",
      emailPh: "maria@esempio.com",
      tour: "Quale tour ti interessa?",
      tourPh: "Scegli un tour",
      guests: "Quanti siete?",
      guestsPh: "Es. 2 adulti",
      date: "Data indicativa",
      message: "Costruisci la tua esperienza su misura",
      messagePh: "Se hai in mente un itinerario specifico o vuoi unire più località, scrivimi qui le tue idee, i tuoi interessi o esigenze particolari.",
      submit: "Invia la richiesta",
      sending: "Invio in corso...",
      successTitle: "Richiesta inviata!",
      success: "Grazie! Ho ricevuto la tua richiesta: ti scriverò personalmente al più presto con il prezzo del tour.",
      error: "Qualcosa è andato storto. Si apre la tua app email con il messaggio già pronto: premi invia lì.",
      errorFallbackSubject: "Richiesta tour dal sito",
      privacy: "I tuoi dati servono solo a risponderti. Niente spam, promesso.",
    },
    footer: {
      tagline: "Tour privati con guida locale tra Napoli, Campi Flegrei, isole e Costiera Amalfitana.",
      toursTitle: "I tour",
      contactTitle: "Contatti",
      email: "beyondnaplestours@libero.it",
      place: "Napoli, Campania — Italia",
      admin: "Area riservata",
      rights: "Tutti i diritti riservati.",
    },
    admin: {
      title: "Area riservata",
      subtitle: "Accedi per vedere le richieste ricevute.",
      email: "Email",
      password: "Password",
      login: "Accedi",
      loggingIn: "Accesso...",
      logout: "Esci",
      dashboard: "Richieste ricevute",
      empty: "Nessuna richiesta ancora. Appena arriva, la vedi qui.",
      mailSent: "Email inviata",
      mailPending: "Solo salvata (email non configurata)",
      loginError: "Accesso non riuscito. Controlla email e password.",
    },
  },
  en: {
    nav: { tours: "Tours", guide: "Your Guide", about: "About me", request: "Request prices", cta: "Book your tour" },
    hero: {
      overline: "Private tours with a local guide — Naples · Phlegraean Fields · Islands · Coast",
      line1: "A land of myths,",
      line2: "sea and volcanoes",
      sub: "Discover Naples, the Phlegraean Fields, the Amalfi and Sorrento Coasts and the islands of the bay on private tours built entirely around you. Experience Campania beyond the usual tourist routes — create your perfect experience and request a personalized quote!",
      cta1: "Explore the tours",
      cta2: "Request a quote",
      badge: "Naples, Campania — Italy",
    },
    marquee: ["Naples", "Pozzuoli", "Solfatara", "Lake Averno", "Lake Lucrino", "Baia", "Pompeii", "Capri", "Ischia", "Procida", "Positano", "Amalfi", "Ravello"],
    tours: {
      overline: "The Tours",
      title1: "Ten wonders.",
      title2: "Don't just hear about them — live them!",
      sub: "Every tour is a full, private day shaped around you. Tap a destination to see the itinerary.",
      fullDay: "Full day",
      day1: "Day 1",
      day2: "Day 2",
      open: "View the tour",
    },
    modal: {
      highlights: "What we'll see",
      cta: "Request the price of this tour",
      close: "Close",
      note: "Price on request — I'll reply privately with a tailored quote.",
    },
    manifesto: {
      overline: "Your Guide",
      title1: "Let me be",
      title2: "your guide.",
      chapters: [
        {
          n: "01",
          title: "A guide, not an agency",
          text: "No thirty-person groups and raised flags. With me you walk alongside someone who lives this land every day: alleys, markets, viewpoints and stories you won't find in guidebooks.",
        },
        {
          n: "02",
          title: "Every tour is tailor-made",
          text: "More history, more sea or more food? You set the pace. Each day is built together, around your interests, your timing and the season.",
        },
        {
          n: "03",
          title: "Clear prices, in private",
          text: "I don't publish price lists because every experience is different: group size, duration, tickets and transfers all change the price. Tell me which tour you want and I'll personally reply with a transparent quote.",
        },
      ],
    },
    about: {
      overline: "About me",
      title: "My story, your peace of mind.",
      photoAlt: "Guido Formichella on the Posillipo belvedere with the Bay of Naples behind him",
      intro: "My name is Guido Formichella. After a degree in Law, I chose to follow my true nature: turning people's free time into unforgettable memories.",
      points: [
        { lead: "From the ground up to the world:", text: "I learned tourism in the field as an entertainment manager in holiday resorts and worked for years in travel agencies, learning to handle every detail that makes a holiday perfect." },
        { lead: "The choice:", text: "I've travelled the world far and wide and seen extraordinary views, but in the end I understood one thing: the most beautiful place is still home." },
        { lead: "The mission:", text: "as a traveller, I decided to help others travel better. Today I put my experience at your service, guiding you through Naples, Pozzuoli, Lake Averno, Lake Lucrino, the Coast and our islands. I won't be a simple guide, but a local friend who knows how to make you live every corner with total safety, professionalism and fun." },
      ],
      closing: "Hop on board. I'll make you fall in love with my land.",
    },
    enquiry: {
      overline: "Prices on request",
      title1: "Choose the experience",
      title2: "you want to live.",
      sub: "You'll receive a personalized quote based on your needs. Fill in the form: I'll personally reply by email with the price and every detail to plan your day.",
      name: "Full name",
      namePh: "Jane Smith",
      email: "Your email",
      emailPh: "jane@example.com",
      tour: "Which tour are you interested in?",
      tourPh: "Choose a tour",
      guests: "How many of you?",
      guestsPh: "E.g. 2 adults",
      date: "Approximate date",
      message: "Build your tailor-made experience",
      messagePh: "If you have a specific itinerary in mind or want to combine several places, write your ideas, interests or special needs here.",
      submit: "Send the request",
      sending: "Sending...",
      successTitle: "Request sent!",
      success: "Thank you! I've received your request: I'll write to you personally very soon with the tour price.",
      error: "Something went wrong. Your email app is opening with the message ready: just press send there.",
      errorFallbackSubject: "Tour request from the website",
      privacy: "Your details are only used to reply to you. No spam, promise.",
    },
    footer: {
      tagline: "Private tours with a local guide across Naples, the Phlegraean Fields, the islands and the Amalfi Coast.",
      toursTitle: "Tours",
      contactTitle: "Contact",
      email: "beyondnaplestours@libero.it",
      place: "Naples, Campania — Italy",
      admin: "Reserved area",
      rights: "All rights reserved.",
    },
    admin: {
      title: "Reserved area",
      subtitle: "Sign in to view incoming requests.",
      email: "Email",
      password: "Password",
      login: "Sign in",
      loggingIn: "Signing in...",
      logout: "Sign out",
      dashboard: "Incoming requests",
      empty: "No requests yet. As soon as one arrives, you'll see it here.",
      mailSent: "Email sent",
      mailPending: "Saved only (email not configured)",
      loginError: "Sign-in failed. Check email and password.",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("vb-lang") || "it");
  useEffect(() => {
    localStorage.setItem("vb-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
